import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);

// Connect to emulators only if explicitly enabled
const useEmulator = import.meta.env.VITE_USE_EMULATOR === 'true';

if (useEmulator) {
  try {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, '127.0.0.1', 8080);
  } catch (error) {
  }
} else {
  
  // Temporarily disable persistence to test if it's causing timeouts
  // enableIndexedDbPersistence(db)
  //   .then(() => {
  //   })
  //   .catch((err) => {
  //     if (err.code === 'failed-precondition') {
  //       console.warn('⚠️ Multiple tabs open, persistence can only be enabled in one tab at a time.');
  //     } else if (err.code === 'unimplemented') {
  //       console.warn('⚠️ The current browser doesn\'t support persistence.');
  //     } else {
  //       console.error('❌ Persistence error:', err);
  //     }
  //   });
}

export { auth, db, app };
